import { ResponsiveLine } from "@nivo/line";
import type { PricePerCMSquared } from "../../../models/PricePerCMSquared";

interface Props {
  pricePerCMSquared: PricePerCMSquared[];
}

const PricePerCMSquaredChart: React.FC<Props> = ({ pricePerCMSquared }) => {
  return (
    <div style={{ height: 400 }}>
      <ResponsiveLine
        data={[
          {
            id: "Price per cm",
            data: pricePerCMSquared.map((item) => ({
              x: `${item._id.year}`, // Format date as 'YYYY-MM'
              y: item.price_per_cm,
            })),
          },
        ]}
        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
        xScale={{ type: "point" }}
        yScale={{
          type: "linear",
          min: "auto",
          max: "auto",
          stacked: true,
          reverse: false,
        }}
        axisTop={null}
        axisRight={null}
        colors={{ scheme: "nivo" }}
        pointSize={10}
        pointColor={{ theme: "background" }}
        pointBorderWidth={2}
        pointBorderColor={{ from: "serieColor" }}
        pointLabelYOffset={-12}
        useMesh={true}
        legends={[
          {
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: "left-to-right",
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: "circle",
            symbolBorderColor: "rgba(0, 0, 0, .5)",
            effects: [
              {
                on: "hover",
                style: {
                  itemBackground: "rgba(0, 0, 0, .03)",
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
};
export default PricePerCMSquaredChart;
